import Grid from '@mui/material/Grid2';
import { type ReactNode } from 'react';

import { type AccessoryOrderEntry } from '@/hooks/useAccessoryOrderItems';

import { AccessoryOrderSummary } from './AccessoryOrderSummary';

/** Main content beside the order summary. */
export function AccessoryOrderLayout({ entries, children }: { entries: AccessoryOrderEntry[]; children: ReactNode }) {
  return (
    <Grid container spacing={{ xs: 6, lg: 8 }} alignItems="flex-start">
      <Grid size={{ xs: 12, lg: 8 }}>{children}</Grid>
      <Grid size={{ xs: 12, lg: 4 }}>
        <AccessoryOrderSummary entries={entries} showActions={false} />
      </Grid>
    </Grid>
  );
}
